var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5109 4.04134H5.36255C3.8612 4.04134 2.6441 5.25843 2.6441 6.75979V9.40311M17.8551 8.66667L10.0958 16.4444L6.2254 12.5556M5.49515 22H18.5049C20.4352 22 22 20.4352 22 18.5049V5.49515C22 3.56483 20.4352 2 18.5049 2H13.7097C12.8927 2 12.1586 2.49595 11.8396 3.24814C11.2211 4.70626 10.1876 7.03335 9.52967 7.93023H5.49515C3.56483 7.93023 2 9.49506 2 11.4254V18.5049C2 20.4352 3.56483 22 5.49515 22Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.7a81774c538e05eb67bf54d5c2aee4e6.svg";
export { ForwardRef as ReactComponent };